import Products from './Products';

export default Products;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/Inventory/Products/index.tsx